import { createNavigationContainerRef, StackActions } from '@react-navigation/native';

const navigationRef = createNavigationContainerRef();

function navigate(name: string, params?: unknown) {
  navigationRef.isReady() && navigationRef.navigate(name as never, params as never);
}
function goBack() {
  navigationRef.isReady() && navigationRef.goBack();
}

function push(name: string, params?: unknown) {
  navigationRef.isReady() && navigationRef.dispatch(StackActions.push(name, params as never));
}
function pop(count?: number) {
  navigationRef.isReady() && navigationRef.dispatch(StackActions.pop(count));
}
function popToTop() {
  navigationRef.isReady() && navigationRef.dispatch(StackActions.popToTop());
}

// Old methods (TODO: need to fix types, and remove some methods)
const replace = (name: string, params?: never) => {
  navigationRef.reset({ index: 0, routes: [{ name, params }] });
};

const getCurrentOptions = () => navigationRef.getCurrentOptions();

const getCurrentRoute = () => navigationRef.getCurrentRoute()?.name;

const getCurrentRouteParameters = () => navigationRef.getCurrentRoute()?.params;

const getCurrentStack = () => navigationRef.getState()?.routes;

const setParameters = (params: never) => navigationRef.setParams(params);

export const navigationService = {
  navigationRef,
  navigate,
  goBack,
  push,
  pop,
  popToTop,
  replace,
  getCurrentOptions,
  getCurrentRoute,
  getCurrentRouteParameters,
  getCurrentStack,
  setParameters,
};
